<div class="tt-c-dimension tt-u-mb--xl" :class="['tt-c-dimension--' + type]">
  <div class="tt-c-dimension__heading tt-u-mb--sm">
    <span class="tt-c-dimension__label">{{ label }}<template v-if="valueLabel || isSelectImage">:</template></span>
    <span v-if="valueLabel" class="tt-c-dimension__value-label">{{ valueLabel }}</span>
    <img v-for="url in imageUrls" class="tt-c-dimension__image" :src="url">
  </div>
  <div v-if="isRating || isRange" class="tt-c-dimension__bar-wrap" :class="['tt-c-dimension__bar-wrap--' + (isRange ? 'range': 'rating')]">
    <div class="tt-c-dimension__bar">
      <span v-if="isRating" class="tt-c-dimension__progress" :style="{width: valuePercentage}"></span>
      <span v-if="isRange" ref="dot" class="tt-c-dimension__dot" :style="{left: valuePercentage}"></span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/review/dimension.html